<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới Lớp học</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row :gutter="20">
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="level_id" label="Chọn phân hệ" class="form-item">
                  <el-select v-model="modelData.level_id" filterable placeholder="" class="input-select">
                    <el-option
                      v-for="item in lists.listLevel"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="facult_id" label="Chọn khoa" class="form-item">
                  <el-select v-model="modelData.facult_id" filterable placeholder="" class="input-select">
                    <el-option
                      v-for="item in lists.listFacult"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="key_id" label="Chọn năm học" class="form-item">
                  <el-select v-model="modelData.key_id" filterable placeholder="" class="input-select">
                    <el-option
                      v-for="item in lists.listKey"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="specialized_id" label="Chọn chuyên ngành" class="form-item">
                  <el-select v-model="modelData.specialized_id" filterable placeholder="" class="input-select">
                    <el-option
                      v-for="item in lists.listSpecialized"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="18">
                <el-form-item prop="name" label="Tên lớp" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="code" label="Mã lớp" class="form-item">
                  <el-input v-model="modelData.code" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'ConfigmenuCreate',
  metaInfo () {
    return {
      title: 'Lớp học'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        level_id: '',
        facult_id: '',
        specialized_id: '',
        key_id: '',
        user_id: '',
        name: '',
        code: '',
        status: true
      },
      lists: {
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listLevel: [],
        listFacult: [],
        listSpecialized: [],
        listKey: []
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên lớp' }
        ],
        code: [
          { required: true, message: 'Vui lòng nhập mã lớp' }
        ],
        level_id: [
          { required: true, message: 'Vui lòng nhập phân hệ' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchLevel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-pros-index', text: 'Lớp học' },
        { name: 'class-pros-create', text: 'Thêm mới' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'class-pros-index'})
    },
    // Fetch dữ liệu về danh mục tin tức
    fetchLevel () {
      axios.get('levels', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchKey () {
      axios.get('keys', {params: {'status': 1, level_id: this.modelData.level_id}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listKey = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      axios.get('facults', {params: {'status': 1, level_id: this.modelData.level_id}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'level_id': this.modelData.level_id,
        'facult_id': this.modelData.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('class-pros', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm thành công',
              type: 'success'
            })
            this.$router.push({name: 'class-pros-update', params: {id: response.data.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {
    'modelData.level_id': function () {
      if (this.modelData.level_id) {
        this.modelData.key_id = ''
        this.modelData.facult_id = ''
        this.fetchKey()
        this.fetchFacult()
      }
    },
    'modelData.facult_id': function () {
      if (this.modelData.facult_id) {
        this.modelData.specialized_id = ''
        this.fetchSpecialized()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/class-users-v2/Create.vue